import type { FC, HTMLAttributes, PropsWithChildren } from "react";
import useScrollSpy from "./useScrollSpy";

type ScrollSpyItemProps = PropsWithChildren<
	HTMLAttributes<HTMLDivElement> & {
		id: string;
		hideId?: boolean;
	}
>;

const ScrollSpyItem: FC<ScrollSpyItemProps> = ({
	id,
	children,
	hideId,
	style,
	...rest
}) => {
	const ref = useScrollSpy(id);
	return (
		<div ref={ref} id={hideId ? undefined : id} style={style} {...rest}>
			{children}
		</div>
	);
};

export default ScrollSpyItem;
